<div class="w-full bg-grey-12">
  <div class="max-w-[1600px] mx-auto">
    <!---------------------------------------- START :: SEO DATA ---------------------------------------------------->
    <div
      class="py-10 leading-loose text-black side-padding font-inter-400 text-17 max-sm:text-12 max-sm:text-center"
    >
      <!-- @if(isLoadingFooter()){

      <div class="flex flex-col gap-4">
        @for (item of nItems; track $index) {
        <div class="bg-grey-skeleton animate-pulse w-full h-[15px]"></div>
        }
      </div>
      } @else {

      <div
        id="footer"
        [innerHTML]="descriptionFooter()"
        [class.force-text]="themeService.getCurrentTheme() === 'dark'"
      ></div>
      } -->
    </div>

    <!-- -------------------------------------- END :: SEO DATA -------------------------------------------------- -->
  </div>
</div>

<div
  class="w-full text-white bg-right-top bg-grey-12 bg-footer side-padding max-sm:pb-10"
  id="footer"
>
  <div
    class="relative w-full max-w-[1600px] mx-auto text-white bg-right-top bg-footer side-padding max-sm:pb-10"
  >
    <img
      alt="top"
      class="bg-white absolute rounded-full cursor-pointer right-16 top-[-30px] max-sm:right-8 max-sm:w-[37px] max-sm:top-[-20px]"
      [src]="urlIcon + 'arrow-up.svg'"
    />

    <div class="pt-12 max-w-[811px] w-full max-sm:pt-10">
      <img
        alt="logo"
        class="max-w-[252px] max-sm:max-w-[114px] w-full cursor-pointer"
        [src]="urlIMG + 'logo-white.png'"
      />

      <div
        class="flex justify-between mt-10 space-x-24 max-sm:space-x-4 text-15 max-sm:text-11"
      >
        <!-- First Column (4 items) -->
        <div class="flex-1 border-r border-black-2">
          <div
            *ngFor="let sport of optionsSports | slice : 0 : 4; let i = index"
            [class]="
              (i !== 3 ? 'mb-5' : '') +
              ' cursor-pointer hover:underline flex items-center gap-5'
            "
          >
            <img
              alt="sport"
              class="w-[22px] max-sm:w-[18px]"
              [src]="urlIMG + 'sports/' + sport.icon + '.svg'"
            />
            {{ sport.text }}
          </div>
        </div>

        <!-- Second Column (4 items) -->
        <div class="flex-1 border-r border-black-2">
          <div
            *ngFor="let sport of optionsSports | slice : 4 : 8; let i = index"
            [class]="
              (i !== 3 ? 'mb-5' : '') +
              ' cursor-pointer hover:underline flex items-center gap-5'
            "
          >
            <img
              alt="sport"
              [ngClass]="{
                'w-[26px] max-sm:w-[22px]': sport.sport === 'Ganadazo',
                'w-[22px] max-sm:w-[18px]': sport.sport !== 'Ganadazo'
              }"
              [src]="
                sport.sport === 'Ganadazo'
                  ? urlIMG + 'sports/torito-footer.svg'
                  : urlIMG + 'sports/' + sport.icon + '.svg'
              "
            />
            {{ sport.text }}
          </div>
        </div>

        <!-- Third Column (Static items) -->
        <div class="flex-1">
          <div
            class="relative flex items-center gap-5 mb-5 cursor-pointer hover:underline"
          >
            <div class="w-[20px] max-sm:w-[10px]"></div>
            <img
              alt="book"
              class="w-[40px] max-sm:w-[30px] absolute left-[-8px]"
              [src]="urlIcon + 'book.png'"
            />
            {{ "ComplaintsBook" }}
          </div>
          <!-- <div
            class="flex items-center gap-5 mb-5 cursor-pointer hover:underline"

          >
            <img alt="circle" [src]="urlIcon + 'circle-red.svg'" />
            {{ "Odds" | translate }}
          </div> -->
          <div
            class="flex items-center gap-5 mb-5 cursor-pointer hover:underline"
            routerLink="contact-us"
          >
            <img alt="circle" [src]="urlIcon + 'circle-red.svg'" />
            {{ "Contáctanos" }}
          </div>
          <div
            class="flex items-center gap-5 mb-5 cursor-pointer hover:underline"
            routerLink="politicas-privacidad"
          >
            <img alt="circle" [src]="urlIcon + 'circle-red.svg'" />
            {{ "Políticas de Privacidad" }}
          </div>
          <div class="flex items-center gap-5 cursor-pointer hover:underline">
            <img alt="circle" [src]="urlIcon + 'circle-red.svg'" />
            {{ "Políticas de cookies" }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex max-w-[1004px] gap-2 items-center justify-between py-10 text-14 max-sm:text-13 max-sm:flex-col-reverse max-sm:justify-start max-sm:py-7"
    >
      <span
        >Copyright © 2024
        <span class="cursor-pointer text-red-2 hover:underline"
          >marcadores247</span
        ></span
      >
      <span
        class="cursor-pointer hover:underline"
        routerLink="politicas-privacidad"
      >
        {{ "Políticas de privacidad" }}</span
      >
      <span
        class="cursor-pointer hover:underline"
        routerLink="condiciones-de-uso"
      >
        {{ "Términos y Condiciones" }}
      </span>

      <div class="flex gap-4 max-sm:gap-2">
        <div
          class="bg-red-2 cursor-pointer rounded-full w-[40px] h-[40px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center"
        >
          <img
            alt="instagram"
            class="w-[16px] max-sm:w-[11px]"
            [src]="urlIcon + 'insta-white.svg'"
          />
        </div>
        <div
          class="bg-red-2 cursor-pointer rounded-full w-[40px] h-[40px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center"
        >
          <img
            alt="youtube"
            class="w-[18px] max-sm:w-[12px]"
            [src]="urlIcon + 'youtube-white.svg'"
          />
        </div>
        <div
          class="bg-red-2 cursor-pointer rounded-full w-[40px] h-[40px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center"
        >
          <img
            alt="tiktok"
            class="w-[14px] max-sm:w-[9px]"
            [src]="urlIcon + 'tiktok-white.svg'"
          />
        </div>
        <div
          class="bg-red-2 cursor-pointer rounded-full w-[40px] h-[40px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center"
        >
          <img
            alt="facebook"
            class="w-[9px] max-sm:w-[6px]"
            [src]="urlIcon + 'facebook-white.svg'"
          />
        </div>
        <div
          class="bg-red-2 cursor-pointer rounded-full w-[40px] h-[40px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center"
        >
          <img
            alt="linkedin"
            class="w-[15px] max-sm:w-[10px]"
            [src]="urlIcon + 'linkedin-white.svg'"
          />
        </div>
      </div>
    </div>
  </div>
</div>
